/** A demo-scene sine scroller: text running right to left, letters bobbing on a wave, colours flowing. */

import { GLYPH } from '../../render/font';
import type { Screen } from '../../render/screen';
import { wrapIndex } from './menuModel';
import { calmStep, RAINBOW } from './theme';

/** Where the first copy of a looping text of width `textW` starts after `travelled` pixels. Pure. */
export function marqueeStart(travelled: number, textW: number): number {
  return textW <= 0 ? 0 : -(((Math.floor(travelled) % textW) + textW) % textW);
}

export class Marquee {
  private travelled = 0;
  private readonly chars: string[];

  /** `text` loops end to start; give it a separator at the end. */
  constructor(text: string, private readonly speed = 42) {
    this.chars = [...text];
  }

  update(dtMs: number): void {
    this.travelled += (dtMs * this.speed) / 1000;
  }

  /** Letters bob `wave` pixels about `y`; `colours` flow along the text. */
  draw(screen: Screen, y: number, ms: number, wave = 3, colours: readonly number[] = RAINBOW): void {
    const textW = this.chars.length * GLYPH;
    let x = marqueeStart(this.travelled, textW);
    const shift = Math.floor(ms / calmStep(90));
    while (x < screen.width) {
      this.chars.forEach((ch, i) => {
        const cx = x + i * GLYPH;
        if (ch === ' ' || cx <= -GLYPH || cx >= screen.width) return;
        const dy = Math.round(Math.sin((cx + ms * 0.12) / 22) * wave);
        const colour = colours[wrapIndex(Math.floor(cx / 24) - shift, colours.length)] ?? 1;
        screen.text(ch, cx, y + dy, colour);
      });
      x += textW;
    }
  }
}
